import { render, staticRenderFns } from "./Service_SubForm.vue?vue&type=template&id=047c843a&"
import script from "./Service_SubForm.vue?vue&type=script&lang=js&"
export * from "./Service_SubForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports